const LOCAL_STORAGE = {
  ACCESS_TOKEN: 'ONECMS_AccessToken',
  REFRESH_TOKEN: 'ONECMS_RefreshToken',
  ABILITIES: 'ONECMS_Abilities',
  LANGUAGE: 'ONECMS_Language',
  PREVIEW_DATA: 'ONECMS_PreviewData',
  FINDER_TREE_SELECTED: 'ONECMS_TreeSelected',
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const COLORS = {
  COOL_BLACK: '#002b60',
};

export const DEFAULT_QUERY_OPTION = {
  retry: 0,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

export const URL_CONST = {
  MEDIA_FILE_UPLOAD_CHUNK: 'api/v1/media-files/upload-chunk',
  MEDIA_FILE_MERGE_CHUNK: 'api/v1/media-files/merge-chunk',
};

export const URL_CONST_CLIENT = {
  FILE_CLIENT_UPLOAD_CHUNK: 'api/v1/clients/files/upload-chunk',
  FILE_CLIENT_MERGE_CHUNK: 'api/v1/clients/files/merge-chunk',
};

export const TARGET_LIST_OPTIONS = [
  {
    label: 'Mở liên kết trong tab hiện tại',
    value: 1,
  },
  {
    label: 'Mở liên kết trong tab mới',
    value: 2,
  },
];
export const TARGET_LIST_LABEL = [
  {
    label: '_self',
    value: 1,
  },
  {
    label: '_blank',
    value: 2,
  },
];

export const socialList: OptionType[] = [
  {
    label: 'Facebook',
    value: 1,
  },
  {
    label: 'Twitter',
    value: 2,
  },
];

export const newsListSortBy: OptionType[] = [
  {
    label: 'Thứ tự hiển thị',
    value: 'displayOrder',
  },
  {
    label: 'Ngày đăng',
    value: 'displayOrder',
  },
];

export const newsListSortType: OptionType[] = [
  {
    label: 'Ascending',
    value: 'asc',
  },
  {
    label: 'Descending',
    value: 'desc',
  },
];

export default LOCAL_STORAGE;

export const INTEGER_REGEX = /^[+-]?((\d*\.?\d+(?:[Ee][+-]?\d+)?)|(\d+\.))$/;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^0[1-9][0-9]{8}$/;

export const ROUTE_PATHS = {
  /* BLOCK TEMPLATE */
  PAGE_TEMPLATE_MANAGEMENT: '/page-templates',
  /* PAGE */
  PAGE_MANAGEMENT: '/page-management',
  PAGE_DETAIL: '/page',
  PAGE_COMPARE_PACKAGE: '/page-compare-package',
  /* FILE */
  FILE_MANAGEMENT: '/files-management',
  /* MENU */
  MENU_MANAGEMENT: '/menu-management',
  MENU_DETAIL: '/menu',
  /* NEWS */
  NEWS_MANAGEMENT: '/news-management',
  NEWS_DETAIL: '/news',
  NEWS_CATEGORY_MANAGEMENT: '/news-category-management',
  NEWS_CATEGORY_DETAIL: '/news-category',
  /* BANNER */
  BANNER_MANAGEMENT: '/banner-management',
  BANNER_DETAIL: '/banner',
  /* TRANSLATIONS */
  FE_TRANSLATION_MANAGEMENT: '/fe-translation',
  CMS_TRANSLATION_MANAGEMENT: '/cms-translation',
  /* REDIRECT */
  REDIRECT_MANAGEMENT: '/redirect',
  REDIRECT_IMPORT: '/redirect-import',
  /* ACTIVITY */
  ACTIVITY_MANAGEMENT: '/activity-logs',
  /* ROLES */
  ROLES_MANAGEMENT: '/roles',
  ROLES_DETAIL: '/role-detail',
  /* USERS */
  USERS_MANAGEMENT: '/users-management',
  USERS_DETAIL: '/user',
  /* FAQ */
  FAQ_MANAGEMENT: '/faq-management',
  FAQ_DETAIL: '/faq',
  FAQ_CATEGORY_MANAGEMENT: '/faq-category-management',
  FAQ_CATEGORY_DETAIL: '/faq-category',
  /* CONFIG */
  SYSTEM_MANAGEMENT: '/system',
  SYSTEM_CONFIG_MANAGEMENT: '/config-management',
  ERRORS_MANAGEMENT: '/errors-management',
  /* AUTH */
  LOGIN: '/login',
  /* CONTACT */
  CONTACT_MANAGEMENT: '/contact-management',
  CONTACT_PROBLEM_MANAGEMENT: '/contact-problem-management',
  CONTACT_PROBLEM_DETAIL: '/contact-problem-detail',
  /* EMAIL TEMPLATE */
  EMAIL_TEMPLATE_MANAGEMENT: '/email-template-management',
  EMAIL_TEMPLATE_DETAIL: '/email-template-detail',
  /* FORM */
  FORM_MANAGEMENT: '/form-management',
  FORM_DETAIL: '/form-detail',
  SUBMIT_FORM_MANAGEMENT: '/submit-form-management',
  SUBMIT_FORM_LIST_BY_FORM: '/submit-form-list-by-form',
  /* STATIC BLOCK */
  STATIC_BLOCK_MANAGEMENT: '/static-block-management',
  STATIC_BLOCK_DETAIL: '/static-block-detail',
  /* CUSTOMER */
  CUSTOMER_MANAGEMENT: '/customer-management',
  CUSTOMER_DETAIL: '/customer-detail',
  /* CLIENT */
  CLIENT_MANAGEMENT: '/client-management',
  CLIENT_DETAIL: '/client-detail',
  CLIENT_EDIT: '/client-edit',
  /* PACKAGES */
  PACKAGES_MANAGEMENT: '/packages-management',
  PACKAGES_DETAIL: '/packages-detail',
  PACKAGES_DETAIL_VIEW: '/packages-detail-view',

  /* Add on package detail */
  ADD_ON_PACKAGE: '/add-on-packages',
  ADD_ON_PACKAGE_DETAIL_VIEW: '/add-on-packages-detail-view',
  ADD_ON_PACKAGE_DETAIL: '/add-on-packages-detail',

  /* BLOG CATEGORY */
  BLOG_CATEGORY_MANAGEMENT: '/blog-category-management',
  BLOG_CATEGORY_DETAIL: '/blog-category-detail',
  /* BLOG */
  BLOG_MANAGEMENT: '/blog-management',
  BLOG_DETAIL: '/blog-detail',
  /* KNOWLEDGE BASE */
  KNOWLEDGE_BASE_DETAIL: '/knowledge-base-detail',
  KNOWLEDGE_BASE_VIEW: '/knowledge-base-view',
  KNOWLEDGE_BASE_MANAGEMENT: '/knowledge-base-management',
};

export const videoTypes: OptionType[] = [
  {
    label: 'Upload',
    value: 'upload',
  },
  {
    label: 'Youtube',
    value: 'youtube',
  },
  {
    label: 'Vimeo',
    value: 'vimeo',
  },
];

export const defaultSessionsCode = {
  hanoiCode: '1028580',
  sontayCode: '9074107',
  saigonCode: '1028581',
  danangCode: '1028809',
};

export const KNOWLEDGE_SOURCES = {
  WEBSITE: 1,
  FILES: 2,
  SHAREPOINT: 3,
  GOOGLE_DRIVE: 4,
  CONFLUENCE: 5,
  ONEDRIVE: 6,
  PRIVATE_CLOUD: 7,
};

export const PACKAGE_DURATION_LABELS = {
  1: 'package.aWeek',
  2: 'package.aMonth',
  3: 'package.aYear',
  4: 'package.unlimited',
};

export const BUTTON_EXAMPLES = {
  bookDemo: {
    label: 'Book a Demo (Button)',
    code: `<a
  href="https://your-company.com/book-demo"
  target="_blank"
  rel="noopener noreferrer"
  style="
    display: inline-block;
    background-color: #f96619;
    color: white;
    font-size: 16px;
    font-weight: 600;
    padding: 8px 14px;
    border: 1px solid #f96619;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: background-color 0.2s ease;
    text-decoration: none;
    font-family: inherit;
    text-align: center;
  "
  onmouseover="this.style.backgroundColor='#E64A19'"
  onmouseout="this.style.backgroundColor='#FF5722'"
>
  <strong>Book a Demo</strong>
</a>`.trim(),
  }
} as const;
